import { nextTick } from "vue"
import { navigateTo, isCurrentRoute } from "@/services/tourNavigationService"

/**
 * Creates a beforeShowPromise function that ensures the user is on the specified route before showing a tour step.
 * If the user is not on the specified route, it will navigate to that route before resolving.
 *
 * @param routeName The name of the route to navigate to if not currently on it
 * @returns A promise that resolves when navigation is complete and DOM has updated
 */
export function ensureRoute(routeName: string) {
   return function () {
      return new Promise<void>((resolve) => {
         if (!isCurrentRoute(routeName)) {
            navigateTo(routeName)
               .then(async () => {
                  // Wait for Vue to update the DOM after navigation
                  await nextTick()
                  resolve()
               })
               .catch(async () => {
                  // Navigate failed, but we'll still resolve to show the step
                  // Still wait for any possible DOM updates
                  await nextTick()
                  resolve()
               })
         } else {
            // Even if we're already on the right route, wait for any pending DOM updates
            nextTick().then(() => {
               resolve()
            })
         }
      })
   }
}
